<template>
  <v-widget title="Training Terbaru">
    <div slot="widget-content">
      <div
        v-if="training_init"
        class="layout justify-center align-center"
        :style="$vuetify.breakpoint.xs ? 'padding:100px 0' : 'padding:400px 0'"
      >
        <v-progress-circular
          indeterminate
          :size="80"
          :width="4"
          color="secondary"
        >
        </v-progress-circular>
      </div>
      <div v-else-if="trainings.length">
        <ul
          :class="$vuetify.breakpoint.xs ? 'block-list' : 'flex-list'"
          class="pa-0"
        >
          <li
            class="px-3"
            v-ripple
            v-for="(item, index) in simpleTrainings"
            :key="`recent-training-${index}`"
          >
            <div
              :class="!$vuetify.breakpoint.xs ? 'thumbnail' : 'thumbnail-xs'"
              class="viewer"
              v-viewer
            >
              <img
                v-for="photo in item.photos"
                :key="`recent-trainings-photos-${index}-${photo.id_pel_photo}`"
                v-lazy="c.PHOTO_TRAINING_URL + photo.pel_photo"
                :alt="`Photo-${index}-${photo.id_pel_photo}`"
              />
              <img
                v-if="!item.photos.length"
                v-lazy="c.PHOTO_TRAINING_URL + 'no-image.png'"
                alt="No Image"
              />
            </div>
            <div
              :class="$vuetify.breakpoint.xs ? '' : 'ml-3'"
              style="overflow: hidden"
            >
              <router-link
                :to="{ name: 'TrainingList', query: { id: item.id_training } }"
              >
                <h3 class="title">
                  {{ item.materi }}
                </h3>
              </router-link>
              <div class="caption text--darken-1">
                <router-link
                  :to="{ name: 'User', query: { id: item.id_user } }"
                >
                  {{ item.username }} </router-link
                >,
                <span>{{ item.waktu_mulai | niceDate }}</span>
                <span> ({{ item.waktu_mulai | moment("from", "now") }})</span>
              </div>
              <div :style="$vuetify.breakpoint.xs ? 'overflow-x: scroll' : ''">
                <div class="py-1">
                  <v-chip
                    v-for="(client, i_client) in item.clients"
                    :key="`recent-trainings-clients-${index}-${i_client}`"
                    color="secondary"
                    small
                    text-color="white"
                  >
                    <router-link
                      :to="{
                        name: 'ClientList',
                        query: { id: client.id_client }
                      }"
                      class="white--text"
                      style="text-decoration: none"
                    >
                      <v-avatar class="primary">{{
                        client.peserta_hadir
                      }}</v-avatar>
                      {{ client.client }}
                    </router-link>
                  </v-chip>
                </div>
                <v-chip
                  v-for="trainer in item.trainers"
                  :key="`recent-trainings-trainers-${index}-${trainer.id_trainer}`"
                  color="grey"
                  small
                  label
                  text-color="white"
                >
                  <router-link
                    :to="{
                      name: 'TrainerList',
                      query: { id: trainer.id_trainer }
                    }"
                    class="white--text"
                    style="text-decoration: none"
                  >
                    {{ trainer.trainer }}
                  </router-link>
                </v-chip>
                <div class="o-flex justify-space-between">
                  <div class="social">
                    <span>
                      <v-icon small>filter_hdr</v-icon>
                      <small class="mr-3">{{ item.pel_tempat }}</small>
                    </span>
                    <span>
                      <v-icon small>label</v-icon>
                      <small class="mr-3">{{ item.pel_tipe }}</small>
                    </span>
                    <span>
                      <v-icon small>access_time</v-icon>
                      <small class="mr-3">{{ item.durasi }}</small>
                    </span>
                    <span>
                      <v-icon small>location_city</v-icon>
                      <small class="mr-3">{{ item.total_client }}</small>
                    </span>
                    <span>
                      <v-icon small>directions_run</v-icon>
                      <small class="mr-3">{{ item.total_trainer }}</small>
                    </span>
                    <span>
                      <v-icon small>group</v-icon>
                      <small class="mr-3">{{ item.total_peserta }}</small>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
        <v-divider></v-divider>
        <v-layout justify-center>
          <v-flex xs12 sm8 class="text-xs-center">
            <v-pagination v-model="page" :length="length" circle>
            </v-pagination>
          </v-flex>
        </v-layout>
      </div>
      <div
        v-else
        class="layout justify-center align-center"
        style="padding: 200px 0"
      >
        <h2>Belum ada data.</h2>
        <v-icon medium>sentiment_very_dissatisfied</v-icon>
      </div>
    </div>
  </v-widget>
</template>

<script>
import _ from "lodash";
import c from "@/constants";
import VWidget from "@/components/widgets/VWidget";
import { mapState, mapGetters } from "vuex";

export default {
  name: "recent-training",
  props: {
    n: {
      type: Number,
      default: 5
    }
  },
  components: {
    VWidget
  },
  data() {
    return {
      c: c,
      page: 1,
      nLocal: -1
    };
  },
  computed: {
    ...mapState(["id_laman$"]),
    ...mapState("training", ["training_init"]),
    ...mapGetters("training", ["trainingByLamanPeriode"]),
    trainings() {
      let start = (this.page - 1) * this.n;
      let end = start + this.n;
      return _.orderBy(
        this.trainingByLamanPeriode,
        "waktu_mulai",
        "desc"
      ).slice(start, end);
    },
    simpleTrainings() {
      return this.trainings.filter(
        (_, i) => i < this.nLocal || this.nLocal < 0
      );
    },
    length() {
      return Math.round(this.trainingByLamanPeriode.length / this.n);
    }
  },
  watch: {
    id_laman$() {
      this.page = 1;
    }
  },
  mounted() {
    this.nLocal = _.cloneDeep(this.n);
  }
};
</script>

<style scoped>
.social span {
  display: inline-block;
}
.flex-list {
  flex-direction: column;
}
.flex-list li {
  display: flex;
  padding: 15px 0;
  border-bottom: 1px solid #eee;
}
.block-list {
  overflow: scroll;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;
}
.block-list li {
  display: inline-block;
  width: 350px;
}
.flex-list li:last-child,
.block-list li:last-child {
  border: none;
}
.thumbnail {
  position: relative;
  min-width: 100px;
  height: 100px;
  overflow: hidden;
  background-color: grey;
}
.thumbnail-xs {
  position: relative;
  width: 100%;
  height: 150px;
  overflow: hidden;
  margin-top: 10px;
  margin-bottom: 5px;
  background-color: grey;
}
.thumbnail img,
.thumbnail-xs img {
  position: absolute;
  text-align: center;
  left: 50%;
  top: 50%;
  height: 100%;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
li a {
  text-decoration: none;
}
</style>
